import api from '../config/api';

const searchPublicPosts = async ({ q, category, shopSlug, featured, withImages, sort = 'best', page = 0, size = 12 }) => {
  const params = new URLSearchParams();
  if (q) params.append('q', q);
  if (category) params.append('category', category);
  if (shopSlug) params.append('shopSlug', shopSlug);
  if (featured !== undefined && featured !== null) params.append('featured', featured);
  if (withImages) params.append('withImages', 'true');
  if (sort) params.append('sort', sort);
  params.append('page', page);
  params.append('size', size);

  const response = await api.get(`/public/posts?${params.toString()}`);
  return response.data;
};

const incrementShareCount = async (postId) => {
  try {
    await api.post(`/public/posts/${postId}/share`);
  } catch (error) {
    console.error('Failed to track share:', error);
  }
};

const incrementViewCount = async (postId) => {
  try {
    await api.post(`/public/posts/${postId}/view`);
  } catch (error) {
    console.error('Failed to track view:', error);
  }
};

const postService = { 
  searchPublicPosts, 
  incrementShareCount,
  incrementViewCount
};
export default postService;
